import { Link } from 'react-router-dom';
import { NoContent } from '../Common/NoContent';
import { TransactionType } from '../../helpers/constants';
import LoadingIndicator from '../Common/LoadingIndicator';
import { FC } from 'react';
import { ITransactionHistory } from '../../interfaces/transaction';
import { useErrorHandler } from 'react-error-boundary';

type Props = {
  transactionHistory: ITransactionHistory[],
  fetching: boolean,
  error: Error|null
}

const RecentTransactions: FC<Props> = ({transactionHistory, fetching, error}) => {
  useErrorHandler(error)

  return (
    <div className='card'>
      <div className='card-header'>
        <h4 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-4 mb-1'>Recent Transactions</span>
          <span className='text-muted fw-bold fs-7'>View your most recent 5 transactions</span>
        </h4>

        <div className='card-toolbar'>
          <Link to='/transactions' className='btn btn-sm btn-light-primary'>
            View All
          </Link>
        </div>
      </div>
      <div className='card-body'>
        {(!fetching && transactionHistory.length < 1) ? <NoContent message='No transactions available' /> :
        <div className='table-responsive'>
          {fetching && (transactionHistory.length < 1) ? <LoadingIndicator message='' /> :
          <table className='table table-bordered table-hover align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted bg-light'>
                <th className='ps-4 min-w-300px rounded-start'></th>
                <th className='min-w-100px'>Amount</th>
                <th className='min-w-100px'>Type</th>
                <th className='min-w-70px'>Date</th>
              </tr>
            </thead>

            <tbody>
              {transactionHistory.map((transaction) => {
                const deconstructedDate = new Date(transaction.created_at).toDateString().split(' ')
                return (<tr key={transaction.id}>
                  <td>
                    <div className='d-flex align-items-center'>
                      <div className='d-flex justify-content-start flex-column'>
                        <span className='fw-bold'>Ref: {transaction.id}</span>
                        <span className='text-muted fw-bold text-muted d-block fs-7'>{transaction.description}</span>
                      </div>
                    </div>
                  </td>
                  <td className='align-middle'>
                    <span className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>{parseFloat(transaction.amount).toLocaleString()}</span>
                  </td>
                  <td className='align-middle'>
                    <span className={`badge badge-sm ${
                      transaction.type === TransactionType.CREDIT
                        ? "badge-light-accepted"
                        : "badge-light-cancelled"
                      }`}
                    >{transaction.type}</span>
                  </td>
                  <td className='align-middle'>
                    <div className='symbol symbol-50px me-3 text-center'>
                      <div className='symbol-label bg-light-warning' style={{ display: 'block', lineHeight: '1.2rem', paddingInline: '4px' }}>
                        <div className='text-warning fw-bolder fs-3 pt-3'>{deconstructedDate[2]}</div>
                        <div className='text-warning fs-8'>{`${deconstructedDate[0]}`}</div>
                      </div>
                    </div>
                  </td>
                </tr>)
              })}
            </tbody>
          </table>}
        </div>}
      </div>
    </div>
  );
};

export default RecentTransactions;
